export enum TOAST_STATUS {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  NOTE = 'note',
  ATTENTION = 'attention',
  INFO = 'info',
  INVERTED = 'inverted',
}
